module.exports = __webpack_public_path__ + "images/favicon-96.4418e1c040f829568a8cd4fd185f3dd3.png";